import axios from "axios";

const request = axios.create({
    
    // baseURL: 'https://shengcong.sh3.ikuai7.com', 
    baseURL: 'http://ddspp.vip:30123', 
    timeout: 0
})
request.interceptors.response.use((response)=>{
    return response.data    
},(error)=>{
    return Promise.reject(error)
})


export { request }